module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAJCAYAAAAPU20uAAAABHNCSVQICAgIfAhkiAAAAGxJREFUGFdjFC18cIHhP0vC6wkyFxiQgHDBowQmxv8OjKIFTwz+M/7ZwPifJQCmCCL5r+D3//8OjCBNyIr+MfwzgEl+mKD4AawARREDwweQTpAkSJwR2Q0CBc8VGBh+fABJ0tMNyH5HdgNMHAAsjG72sgkonQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/examinatSystem/sysArrow.png
// module id = ARWm
// module chunks = 3